import React from 'react'
import useStyles from './styles'
import ReadMore from 'components/common/ReadMore/ReadMore'
import WidgetTitle from 'components/common/WidgetTitle/WidgetTitle'
import { useSelector } from 'react-redux'
import { getCurtainValue } from 'redux/slices/curtain'
import { isCurtainOpen } from 'utils/curtain'
import clsx from 'clsx'

interface ParagraphWidgetProps {
    heading: string
    body: string
}

const ParagraphWidget: React.FC<ParagraphWidgetProps> = ({ heading, body }) => {
    const classes = useStyles()
    const curtainValue = useSelector(getCurtainValue)

    return (
        <section className={clsx(!isCurtainOpen(curtainValue) && classes.animateOnCurtainClosed)}>
            <WidgetTitle heading={heading} />
            <ReadMore text={body} limit={600} className={classes.bodyText} />
        </section>
    )
}

export default React.memo(ParagraphWidget)
